import * as next from '../../../types/next'
import { CONTROL_NAME } from '../../../utils/blocks/types'
import type * as current from '../../../utils/types/sharedTypes'
import type { UpBlockHandler } from '../types'
import { findBlockIdWithStepId, newId } from '../utils'

import { upCommonSettings } from './common'

export const up: UpBlockHandler<next.ProductCategoriesBlock> = (
  uischema: current.BlockUiSchema,
  _,
  journey: current.Journey | undefined
) => {
  if (uischema.type !== CONTROL_NAME.PRODUCT_CATEGORY_CONTROL) {
    throw new Error('Expected a valid Shopping Cart control')
  }

  if (!journey) {
    throw new Error('Journey is required')
  }

  return {
    type: next.BLOCK_TYPE.PRODUCT_CATEGORIES,
    settings: {
      ...upCommonSettings(uischema)
    },
    references: upReferences(uischema.options?.relatedProductSelection, journey)
  } as next.ProductCategoriesBlock
}

const upReferences = (
  relatedProductSelection: string,
  journey: current.Journey
): Record<next.ReferenceId, next.ProductsBlockReference> => {
  const references: Record<next.ReferenceId, next.ProductsBlockReference> = {}

  if (!relatedProductSelection) {
    return references
  }

  const referenceId = newId<next.ReferenceId>()
  const [stepId, blockName] = relatedProductSelection.split('/')
  const blockId = findBlockIdWithStepId(journey, stepId, blockName)

  if (!blockId) {
    throw new Error(
      `Block not found for stepId: ${stepId} and blockName: ${blockName}`
    )
  }

  references[referenceId] = {
    meaning: 'related-products',
    referenceId: blockId,
    id: referenceId,
    referenceType: next.REFERENCED_TYPE.BLOCK
  }

  return references
}
